import { render } from "./HeroApprovalOfficialBusinessModal.vue?vue&type=template&id=ed3688c2&scoped=true"
import script from "./HeroApprovalOfficialBusinessModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalOfficialBusinessModal.vue?vue&type=script&lang=js"

import "./HeroApprovalOfficialBusinessModal.vue?vue&type=style&index=0&id=ed3688c2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3688c2"]])

export default __exports__